<template>
  <div class="delete-modal">
    <modal :show.sync="localDisplay">
      <div class="row d-flex mt-3 justify-content-center">
        <div class="col-11 text-center">
          <modal-header
            :style-name="{ backgroundColor: '#0081F90D' }"
            class="mb-3"
          >
            <div slot="icon" class="d-inline-flex">
              <font-awesome-icon
                class="icon blue-mayday"
                :icon="['fal', 'globe-americas']"
              />
            </div>
            <div class="mt-3">
              <div>
                <p class="mb-0 font-weight-bold">
                  {{
                    $t('translation.modal.header', {
                      language: $t(`knowledge.languages.${language}`),
                    })
                  }}
                </p>
              </div>
            </div>
          </modal-header>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-11 text-center">
          <div class="input-label">
            {{
              $t('translation.modal.input-label', {
                language: $t(`knowledge.languages.${language}`),
              })
            }}
          </div>
          <div class="rounded-input">
            <input
              ref="input"
              :placeholder="$t('translation.modal.input-placeholder')"
              v-model="label"
              @keyup.enter="$emit('set-new-language', label)"
            />
          </div>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-between">
        <el-button
          class="ml-1"
          type="danger"
          size="small"
          @click="$emit('close')"
          >{{ $t('translation.modal.cancel') }}</el-button
        >
        <el-button
          class="mr-1"
          type="primary"
          size="small"
          :disabled="!label"
          @click="$emit('set-new-language', label)"
          >{{ $t('translation.modal.validate') }}</el-button
        >
      </div>
    </modal>
  </div>
</template>
<script>
import ModalHeader from '@/components/Modals/ModalHeader';
import Modal from '@/components/Modal';

export default {
  name: 'set-language-modal',
  props: {
    display: Boolean,
    language: String,
  },
  components: {
    Modal,
    ModalHeader,
  },
  data() {
    return {
      localDisplay: this.display,
      label: '',
    };
  },
  watch: {
    localDisplay() {
      if (!this.localDisplay) this.$emit('close');
    },
  },
  mounted() {
    this.$refs.input.focus();
  },
};
</script>
<style lang="scss" scoped>
.delete-modal {
  :deep() .modal-body {
    padding-bottom: 0px;
  }
}
.content-primary-text-container {
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 4px;
  background-color: rgba($blue-mayday, 0.05);
}

.blue-mayday {
  color: $blue-mayday;
}

.icon {
  width: 26px;
  height: 26px;
}

.input-label {
  font-weight: 700;
  text-align: left;
  color: black;
}

.rounded-input {
  border: 1px solid $grey-5-mayday;
  padding: 4px 0px;
  border-radius: 4px;
  font-size: 14px;
  input {
    width: 100%;
    outline: none;
    border: none;
    padding: 4px 8px;
  }
}
</style>
